import { useTranslation } from 'react-i18next'

import { Checkbox, ReveniAiButton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CheckAllProducts = ({ selectedProducts, products, onCheckAllProducts, onAiAssistant }) => {
  const { t } = useTranslation()

  const getSelectedProductsLabel = () => {
    const count = selectedProducts?.length || 0
    return `${count} ${count === 1 ? t('producto seleccionado') : t('productos seleccionados')}`
  }

  if (!products?.length) {
    return null
  }

  return (
    <Styles.CheckAllContainer>
      <Checkbox
        checked={selectedProducts?.length > 0 && selectedProducts?.length === products?.length}
        onChange={onCheckAllProducts}
        indeterminate={selectedProducts?.length > 0 && selectedProducts?.length < products?.length}
        label={getSelectedProductsLabel()}
      />
      {selectedProducts?.length > 0 && <ReveniAiButton label={t('Asistente inventario IA')} onClick={onAiAssistant} />}
    </Styles.CheckAllContainer>
  )
}

export default CheckAllProducts
